import React from 'react';
import { Badge } from 'react-bootstrap';

const RenderItemResumenStatus = ({ item }) => {
  let variant = 'light';

  if (item === 'activo') {
    variant = 'success'
  } else if (item === 'cancelado') {
    variant = 'danger';
  }

  return <Badge variant={ variant }>{ item }</Badge>
}

export default RenderItemResumenStatus;